export default __webpack_public_path__ + "static/media/t-rex.870d103d.svg";